var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportStepWrapper"},[_c('PowerbiReport',{attrs:{"reportId":_vm.reportId,"workspaceId":_vm.workspaceId,"venueFilterColumn":_vm.venueFilterColumn,"venueFilterTable":_vm.venueFilterTable,"venueFilter":true,"filterVenue":_vm.activeVenue.venueId,"showLoading":false,"showNavbar":false,"fitToWidth":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }